export var DynamicComponentExitReason;
(function (DynamicComponentExitReason) {
    DynamicComponentExitReason["Confirm"] = "confirm";
    DynamicComponentExitReason["Cancel"] = "cancel";
    DynamicComponentExitReason["ForceClose"] = "force";
})(DynamicComponentExitReason || (DynamicComponentExitReason = {}));
//# sourceMappingURL=dynamic-component-registry.types.js.map